import { ruleRunner } from 'validations/ruleRunner';
import { isUrl, isSunUrl } from 'validations/rules';

const Validations = [
  ruleRunner('alternative_url', 'url alternativa', isUrl),
  ruleRunner('url_thankyou_card', 'url de obrigado para cartão', isUrl, isSunUrl),
  ruleRunner('url_thankyou_boleto', 'url de obrigado para boleto', isUrl, isSunUrl),
];

export default Validations;
